import { useTranslation } from 'react-i18next';

import { SectionContainer } from 'components/shared';
import { ClientUserDTO } from 'interfaces';

import styles from './ClientSection.module.css';

type ClientUserData = Pick<
   ClientUserDTO,
   'nip' | 'companyName' | 'address' | 'zipCode' | 'city' | 'phoneNumber' | 'email'
>;

const ClientSection = (client: ClientUserData) => {
   const { t } = useTranslation();
   return (
      <SectionContainer title="Klient">
         <div className={styles.container}>
            <div className={styles.column}>
               <p>{t('clientDetails.section.basicData')}</p>
               <div className={styles.infoBlock}>
                  <p>{t('clients.table.nip')}</p>
                  <p>{client.nip}</p>
               </div>
               <div className={styles.infoBlock}>
                  <p>{t('supplier_orders.table.client_name')}</p>
                  <p>{client.companyName}</p>
               </div>
               <div className={styles.infoBlock}>
                  <p>{t('distribution_center.street')}</p>
                  <p>{client.address}</p>
               </div>
               <div className={styles.infoBlocksContainer}>
                  <div className={styles.infoBlock}>
                     <p>{t('distribution_center.zip')}</p>
                     <p>{client.zipCode}</p>
                  </div>
                  <div className={styles.infoBlock}>
                     <p>{t('distribution_center.city')}</p>
                     <p>{client.city}</p>
                  </div>
               </div>
            </div>
            <div className={styles.column}>
               <p>{t('clientDetails.section.contactData')}</p>
               <div className={styles.infoBlock}>
                  <p>{t('sent_password_reset.phone')}</p>
                  <p>{client.phoneNumber}</p>
               </div>
               <div className={styles.infoBlock}>
                  <p>{t('clients.table.email')}</p>
                  <p>{client.email}</p>
               </div>
            </div>
         </div>
      </SectionContainer>
   );
};

export default ClientSection;
